module.exports = __webpack_public_path__ + "img/pressure.a09fea22.svg";